export class Utilites {
    constructor(debug) {
        this.debug = debug;
    };

    querySelectorAll(el, query) {
        return el.querySelectorAll(query);
    }

    log(msg, label=false) {
        if (this.debug === true) {
            if (label !== false) {
                console.log(label);
            }
            console.log(msg);
        }
    }

    addClass(elements, className) {
        for(let element of Array.from(document.querySelectorAll(elements))) {
            element.classList.add(className);
        }
    }

    removeClass(elements, className) {
        for(let element of Array.from(document.querySelectorAll(elements))) {
            element.classList.remove(className);
        }
    }

    environment() {
        const environment = window.location.hostname.match(/local|itg|cat|www74|producer|www/i);
        let subDomains = {};
        switch (environment[0].toUpperCase()) {
            case 'LOCAL':
            case 'ITG':
            case 'CAT':
                subDomains.moo = 'moo' + environment[0];
                subDomains.cdn = 'cdn' + environment[0];
                break;
            case 'WWW74':
                subDomains.moo = 'mooitg';
                subDomains.cdn = 'cdnitg';
                break;
            case 'PRODUCER':
            case 'WWW':
                subDomains.moo = 'www';
                subDomains.cdn = 'cdn';
                break;
            default:
                subDomains.moo = 'www';
                subDomains.cdn = 'cdn';
                break;
        }
        return subDomains;
    }
}



// WEBPACK FOOTER //
// ./src/modules/Shared/Utilities/index.js